import React from 'react';

const SvgZipcarMultiColor = ({ title, ...props }) => (
  <svg viewBox="0 0 30 30" {...props}>
    {title ? <title>{title}</title> : null}
    <style>{'.zipcar-multi-color_svg__st4{display:inline}'}</style>
    <g id="zipcar-multi-color_svg__zipcar">
      <path
        d="M0 15C0 6.7 6.7 0 15 0s15 6.7 15 15-6.7 15-15 15S0 23.3 0 15z"
        fill="#59ad40"
      />
      <path
        d="M29.1 20.2c.1-.2.2-.4.2-.6H16.7l.6-.8H26c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3h-8.2l.6-.8h4.4c.1 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H11.1l7.2-9.4H6.4V10h6.3l-6.6 8.6-1.4 1.7H10c.4-1.1 1.5-1.9 2.8-1.9 1.3 0 2.3.8 2.8 1.9h13.5z"
        fill="#fff"
      />
      <path
        d="M15.1 21.4c0 1.3-1 2.3-2.3 2.3-1.3 0-2.3-1-2.3-2.3 0-1.3 1-2.3 2.3-2.3 1.3 0 2.3 1 2.3 2.3z"
        fill="#5a5b5d"
      />
    </g>
  </svg>
);

export default SvgZipcarMultiColor;
